// 延迟执行的操作 / Deferred action to run after successful login.
// 仅保留给显式需要登录后继续的流程；启动模拟不再使用自动回放。
// Kept only for flows that explicitly need post-login continuation; simulation
// start no longer uses automatic replay.

type Action = () => void | Promise<void>;

let pending: Action | null = null;

export function setPendingAction(action: Action): void {
  pending = action;
}

export function clearPendingAction(): void {
  pending = null;
}

export async function runPendingAction(): Promise<void> {
  const action = pending;
  pending = null;
  if (action) {
    await action();
  }
}
